var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 20H4a2 2 0 0 1-2-2V5.913A2 2 0 0 1 4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2ZM4 7.868V18h16V7.868L12 13.2 4 7.868ZM4.8 6l7.2 4.8L19.2 6H4.8Z",
    fill: "#BCC2DB"
  })));
};

export { SvgMail as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwIDIwSDRDMi44OTU0MyAyMCAyIDE5LjEwNDYgMiAxOFY1LjkxM0MyLjA0NjYxIDQuODQyNTUgMi45Mjg1MyAzLjk5ODk5IDQgNEgyMEMyMS4xMDQ2IDQgMjIgNC44OTU0MyAyMiA2VjE4QzIyIDE5LjEwNDYgMjEuMTA0NiAyMCAyMCAyMFpNNCA3Ljg2OFYxOEgyMFY3Ljg2OEwxMiAxMy4yTDQgNy44NjhaTTQuOCA2TDEyIDEwLjhMMTkuMiA2SDQuOFoiIGZpbGw9IiNCQ0MyREIiLz4KPC9zdmc+Cg==";